/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_SemesterInputs */

const en__field_semester = /** @type {(inputs: _Field_SemesterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semester`)
};

const de__field_semester = /** @type {(inputs: _Field_SemesterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semester`)
};

/**
* | output |
* | --- |
* | "Semester" |
*
* @param {_Field_SemesterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_semester = /** @type {((inputs?: _Field_SemesterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_SemesterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_semester(inputs)
	return de__field_semester(inputs)
});